<template>
    <div id="apVoucherDistributionEdit">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>

        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title"> AP Voucher Distribution Edit</div>
                    <div class="web-action-btn btn-groups text-right">
                        <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="exportReports()">
                            <i class="fp-export"></i> Export
                        </a>
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content customer-ar-report">
                        <data-table-filter-config :moduleName="'apVoucherDistribution'" :allowSameFilter="'allow'"></data-table-filter-config>
                        <div class="data-table bg-white overflow-hidden">
                          <p v-if="batchProcess" class="alert-success p-2" id="processFetchBatchMsg">Export file is in process. batch no. is {{batchNum}}. <router-link class="color-blue" v-bind:to="{name: 'BatchList'}" target="_blank" @click.native="batchProcess = 0"> Click Here</router-link> to check file status!</p>
                          <section class="data-table bg-white">
                                  <custom-pagination
                                      :page-changed="onPageChange"
                                      :per-page-changed="onPerPageChange" :moduleName="'apVoucherDistribution'" :position="'top'">
                                  </custom-pagination>
                                  <vue-good-table
                                      ref="APVoucherDistribution"
                                      mode="remote"
                                      title="AP Voucher Distribution Edit"
                                      @on-page-change="onPageChange"
                                      @on-column-filter="onColumnFilter"
                                      @on-per-page-change="onPerPageChange"
                                      @on-sort-change="onSortChange"
                                      :totalRows="totalRecords"
                                      :columns="userColumns"
                                      :rows="rows"
                                      :pagination-options="{
                                          enabled: false,
                                          position: 'both',
                                          perPage: perPage,
                                          perPageDropdown:dropDownPerPage,
                                          dropdownAllowAll: false,
                                      }"

                                      :search-options="{
                                      enabled: false,
                                      }">
                                  </vue-good-table>
                                  <custom-pagination
                                      :page-changed="onPageChange"
                                      :per-page-changed="onPerPageChange">
                                  </custom-pagination>
                          </section>
                        </div>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>
import Vue from "vue";
import {commonMixins} from '../../mixins/commonMixins';
import {dataTableMixins} from '../../mixins/dataTableMixins';
export default {
    name: "APVoucherDistributionEdit",
    metaInfo() {
        return {
            title: "AP Voucher Distribution Edit | " +process.env.COPYRIGHT_NAME
        }
    },
    mixins:[commonMixins,dataTableMixins],
    data: () => ({
        firstLoad: 0,
        permissions: [],
        cantAccessPage: "",
        userColumns:[],
        columns: [
            {
                label:'Vendor Name',
                field:'vendor_name',
                fpFieldType:"text",
                filterable: true,
                hidden:false,
            },
            {
                label:'Vendor Number',
                field:'vendor_code',
                fpFieldType:"text",
                filterable: true,
                hidden:false,
            },
            {
                label:'Voucher Comp#',
                field:'voucher_comp',
                fpFieldType:"text",
                filterable: false,
                hidden:false,
                sortable:false
            },
            {
                label:'Voucher Number',
                field:'voucher_number',
                fpFieldType:"text",
                filterable: true,
                hidden:false,
            },
            {
                label:'Invoice Description',
                field:'invoice_description',
                fpFieldType:"text",
                filterable: true,
                hidden:false,
            },
            {
                label:'Invoice Number',
                field:'bill_number',
                fpFieldType:"text",
                filterable: true,
                hidden:false,
            },
            {
                label:'Invoice Amount',
                field:'invoice_amount',
                fpFieldType:"integer",
                filterable: true,
                hidden:false,
                type:'number',
            },
            {
                label:'Voucher Open Amt',
                field:'open_amount',
                fpFieldType:"integer",
                filterable: false,
                hidden:false,
                type:'number',
                sortable:false
            },
            {
                label: "Invoice Date",
                field: "bill_date",
                hidden:false,
                fpFieldType:"custom_date",
                filterable: true,
            },
            {
                label: "Due Date",
                field: "due_date",
                hidden:false,
                fpFieldType:"custom_date",
                filterable: true,
            },
            {
                label: "Discount Date",
                field: "discount_date",
                hidden:false,
                fpFieldType:"custom_date",
                filterable: true,
            },
            {
                label:'PO Number',
                field:'po_number',
                fpFieldType:"text",
                filterable: true,
                hidden:false,
            },
            {
                label:'Distribution Amount',
                field:'item_total',
                fpFieldType:"integer",
                filterable: true,
                hidden:false,
                type:'number',
            },
            {
                label:'Distr Comp#',
                field:'distr_comp',
                fpFieldType:"text",
                filterable: false,
                hidden:false,
                sortable:false
            },
            {
                label:'GL Account',
                field:'gl_account',
                fpFieldType:"text",
                filterable: true,
                hidden:false,
            },
            {
                label:'GL Acct Description',
                field:'gl_account_desc',
                fpFieldType:"text",
                filterable: true,
                hidden:false,
            },
            {
                label:'Posted Year',
                field:'gl_year',
                fpFieldType:"integer",
                type:'number',
                filterable: true,
                hidden:false,
                sortable:true
            },
            {
                label:'Posted Period',
                field:'gl_period',
                fpFieldType:"integer",
                type:'number',
                filterable: true,
                hidden:false,
                sortable:true
            },
            {
                label: "Invoice Add Date",
                field: "invoice_add_date",
                hidden:false,
                fpFieldType:"custom_date",
                filterable: true,
            },
            {
                label:'User Add',
                field:'user_add',
                fpFieldType:"text",
                filterable: true,
                hidden:false,
            },
            {
                label:'GL Line Description',
                field:'gl_line_description',
                fpFieldType:"text",
                filterable: true,
                hidden:false,
            },
            {
                label: "Pmt Type",
                field: "payment_type",
                fpFieldType:"text",
                filterable: true,
                hidden:false,
            },
            {
                label:'Discount Terms',
                field:'discount_terms',
                fpFieldType:"text",
                filterable: true,
                hidden:false,
            },
            {
                label:'Assign Name',
                field:'assignee_name',
                fpFieldType:"text",
                filterable: true,
                hidden:false,
            },
            {
                label:'Assign Number',
                field:'assignee_number',
                fpFieldType:"text",
                filterable: true,
                hidden:false,
            },
            {
                label:'Bank Code',
                field:'bank_code',
                fpFieldType:"text",
                filterable: false,
                hidden:false,
                sortable : false
            },
            {
                label:'Payment Number',
                field:'payment_no',
                fpFieldType:"text",
                filterable: true,
                hidden:false,
            },
            {
                label: "Payment Date",
                field: "payment_date",
                hidden:false,
                fpFieldType:"custom_date",
                filterable: true,
            },
            {
                label: "Cleared Date",
                field: "cleared_date",
                hidden:false,
                fpFieldType:"custom_date",
                filterable: true,
            },
            {
                label:'Tax Code Voucher',
                field:'tax_code_vch',
                fpFieldType:"text",
                filterable: false,
                hidden:false,
                sortable : false
            },
            {
                label: "Vendor 1099 Taxable",
                field: "vendor_taxable",
                fpFieldType:"option",
                filterable: true,
                hidden:false,
            },
            {
                    label: 'Monthly Payable',
                    field: 'monthly_payable',
                    filterable: true,
                    fpFieldType:"option",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Monthly Payable", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter", //only trigger on enter not on keyup
                        filterDropdownItems:["Yes","No"]
                    }
                },
        ],
        rows: [],
        totalRecords: 0,
        loading:false,
        action:'list',
        batchProcess:0,
        batchNum:"",
    }),
    watch: {
        //check permission change
        permissions: function (permissions) {
            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'ap_voucher_distribution_edit_report') {
                        self.cantAccessPage = true;
                    }
                }
            }
        },
    },
    created: function() {
        this.serverParams.stopRequest = true;
    },
    mounted: function() {
        var self = this;

        self.getPermissions();
    },
    methods: {
        // exportReports: function() {
        //     var self = this;
        //     this.action = "export";
        //     this.loadList();
        // },
        loadList: function() {
            var self = this;
            var includePaymentInfo = "";

            if (self.serverParams.columnFilters.length > 0) {
                for(var i = 0;i < self.serverParams.columnFilters.length;i++) {
                    if (self.serverParams.columnFilters[i] != undefined) {
                        if (self.serverParams.columnFilters[i] != null) {
                            if (self.serverParams.columnFilters[i].columnId != null) {
                                if (self.serverParams.columnFilters[i].columnId.field != null) {
                                    if (self.serverParams.columnFilters[i].columnId.field == "include_payment_info") {
                                        includePaymentInfo = self.serverParams.columnFilters[i].filterOptionValue.value;
                                    }
                                }
                            }
                        }
                    }
                }
            }

            if (includePaymentInfo.trim() == "") {
                return;
            }

            var fields = {
                page: self.serverParams.page,
                perPage: self.serverParams.perPage,
                filters: self.serverParams.columnFilters,
                sort: self.serverParams.sort,
                action:self.action,
                paymentFlag:includePaymentInfo
            };

            self.firstLoad = 1;
            self.loading = true;
            $.ajax({
                url: process.env.ROOT_API + "/report/ap-voucher-distribution",
                type: "POST",
                data: fields,
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (data.status == "success") {

                      if (self.action == "export" ||  self.action == "export_queue") {

                          if ( data.code == "201" ) {
                              alert(data.message);
                          } else {

                              if ( self.action == "export" ) {

                                  self.excel = data.content.web;
                                  var save = document.createElement("a");
                                  save.href = self.excel;
                                  save.download = data.content.web;
                                  save.target = "_blank";

                                  document.body.appendChild(save);
                                  save.click();
                                  document.body.removeChild(save);

                              } else {

                                  self.batchProcess = 1;
                                  self.batchNum = data.content;
                              }

                          }

                        self.action = "list";
                        self.loadList();

                      } else {
                        self.rows = data.content.row;
                        self.totalRecords = data.content.totalRecords;
                      }


                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,true,'ap-voucher-distribution-edit')
                }
            });
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/reports/APVoucherDistributionEdit.vue